export const VIBE_DATASET_BOOTSTRAP_PROMPT = `你现在要帮我通过公司 Vibe 数据集大接口，自助创建或恢复一个共享数据集项目，并把我提供的数据源转换成结构化数据后上传。

必须遵守：

1. API Key 只能从当前环境变量 LECHUN_API_KEY 读取。不要让我把 API Key 粘贴到聊天中，不要输出、记录或保存它。
2. 如果当前环境变量中不存在 LECHUN_API_KEY，停止后续操作，并让我打开 https://portal.lechun.cc/portal/profile?tab=apikey，在页面表格下方按当前电脑系统下载环境配置脚本：
   - Mac：下载 ZIP，解压后双击执行。
   - Windows：下载后直接双击执行。
   执行成功后，完全退出并重新打开 Codex，重新检查 LECHUN_API_KEY 已存在后再继续。
3. 使用请求头 \`X-Caller-Key: $LECHUN_API_KEY\` 调用：
   \`GET https://scmapi.lechun.cc/lechun-baseservice/vibeDataset/bootstrap/context\`
4. 为请求生成 UUID 并放入 \`X-Request-Id\`，失败时保留响应中的 requestId 便于技术人员排查。
5. 即使 HTTP 状态是 200，也必须检查 JSON；只有 \`status=200\` 且 \`success=true\` 才算成功。
6. 完整读取并严格执行响应 \`value.instruction\`，不能根据记忆使用旧步骤，也不能跳过用户确认、幂等恢复、数据校验或结果核对。
7. 原始 Excel、CSV、钉钉 AI 表格导出、图片、URL 响应和 PDF 只能在本机读取，不上传原附件、不提交 Git、不直接连接数据库。
8. 最终只汇报项目、表结构、数据量、导入结果和待确认项，不回显 API Key、数据库信息或敏感业务原值。`
